import type { TMessages } from '@/types/TMessages'

export const messages = { articlesHeader: 'Статьи', reactHelmetTitle: 'Рубрика инфопортала: {rubricName}' } satisfies TMessages
